import PassegerList from "./PassengerList";
import LoadTemplate from "./LoadTemplate";
import { Space } from "antd";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { addGroupTripsPassegerAsync } from "../../../features/groupTrip/passeger/groupTripPassegerSlide";
import ModalPassenger from "../common/formPassengers/modalPassenger";
import SelectRequest from "../common/selectRequest";

const Pasajeros = () => {
  const selected = useAppSelector((state) => state.groupTripsRequest.selected);

  const dispatch = useAppDispatch();

  return (
    <Space direction="vertical" style={{ width: "100%", height: "80vh" }}>
      <Space direction="horizontal">
        <SelectRequest />
        {selected && (
          <>
            <ModalPassenger
              addPassengerAction={({ passengerData, requestId, showModal }) => {
                dispatch(
                  addGroupTripsPassegerAsync(
                    passengerData,
                    requestId!,
                    () => showModal && showModal(false),
                  ),
                );
              }}
            />
            <LoadTemplate />
          </>
        )}
      </Space>
      <PassegerList />
    </Space>
  );
};

export default Pasajeros;
